/**
 * This helper will get an env var based on the current environment (development/production)
 */
export default (key: string): string | undefined => {
  return process.env[key];
};
